<template>
    <div class="upload-img-c" @click.stop>
        <img class="triangle" src="../../images/top-v.png">
        <div class="box">
            <img :src="uploadedImg"/>
            <div class="close-icon" @click.stop="handleClose"/>
        </div>
    </div>
</template>
<script>


export default{
    name: 'upload-img',
    props: ['uploadedImg'],
    computed: {},
    data(){
        return {
            
        }
    },
    methods: {
        // 关闭
        handleClose() {
            this.$emit('closeUploadImg')
        }
    }

}
</script>
<style lang="less" scoped>
.upload-img-c {
    .triangle {
        position: absolute;
        bottom: -1px;
        left: 122px;
        width: 13px;
        height: 7px;
    }
    .box {
        z-index: 1;
        cursor: pointer;
        position: absolute;
        top: 101%;
        left: 104px;
        padding: 17px 28px  15px 25px;
        width: 192px;
        background-color: #fff;
        border: 1px solid #dfdfdf;
        border-top: 0;
        border-radius: 6px;
        display: flex;
        justify-content: center;
        box-sizing: border-box;
        img{
            min-height: 60px;
            max-height: 150px;
            min-width: 60px;
            max-width: 150px;
        }
        .close-icon {
            position: absolute;
            right: 7px;
            top: 7px;
            width: 18px;
            height: 18px;
            background: url('../../images/close-img.png') 100% 100% no-repeat;
        }
        .close-icon:hover {
            background: url('../../images/close-img-active.png') 100% 100% no-repeat;
        }
    }
}
</style>
